<template>
    <div>
        <van-list  v-model="loading" :finished="finished" finished-text="没有更多了" @load="getListData">
            <div style="display: flex; color: #333333; font-size: 12px;  background-color: white;  padding: 10px 0 10px 20px; margin-top: 1px;">
                <div style="flex: 3;">时间</div>
                <div style="flex: 2;">姓名</div>
                <div style="flex: 2;">类别</div>
                <div style="flex: 2;">积分</div>
            </div>
            <div v-for="(item,index) in list" :key="index" style="display: flex; color: #333333; font-size: 12px;  background-color: white;  padding: 10px 0 10px 20px; margin-top: 1px;">
                <div style="flex: 3;">{{item.shareDate|dateFormat('YYYY-MM-DD')}}</div>
                <div style="flex: 2;">{{item.userName}}</div>
                <div style="flex: 2;">{{item.shareType === '1' ? '注册' : '购买'}}</div>
                <div style="flex: 2;">{{item.shareIntegral}}</div>
            </div>
        </van-list>
    </div>
</template>

<script>

    import Vue from 'vue';
    import {List} from 'vant';

    Vue.use(List);


    export default {
        name: "IntegralList",
        data() {
            return {
                loading: false,
                finished: false,
                list: [],
                page: 0,
                pageSize: 10,
            }
        },
        methods: {
            getListData() {
                if (this.finished) {
                    return;
                }
                this.page++
                this.loading = true
                this.$axios.get("/integral//list",{params: {page: this.page, limit: this.pageSize}}).then(res => {
                    if (res.code == 200 && res.data.rows) {
                        this.loading = false
                        const data = res.data.rows;
                        this.list = this.list.concat(data)
                        if (data.length < this.pageSize) {
                            this.finished = true;
                        }
                    }
                }).catch(err => {
                    this.loading = false
                    console.log(err);
                })
            }
        }
    }
</script>

<style scoped>

</style>
